module.exports = __webpack_public_path__ + "img/businessLicense2.b06487f7.png";